<!--
 * @Author: Admni
 * @Description: 
 * @Date: 2021-03-11 11:39:25
 * @LastEditTime: 2021-03-12 14:55:30
-->
<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props: {
    chartData: {
      type: Object,
      default: null,
    },
    options: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.options);
  },
};
</script>
